// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/**
 * Enum for udf type values.
 * Specifies the types of user defined functions.
 */
export enum UserDefinedFunctionType {
  /** The User Defined Function is written in JavaScript. This is currently the only option. */
  Javascript = "Javascript",
}
